import React from "react";

export const Education = () => {
  return (
    <div className="container">
      <h1>Education</h1>
    </div>
  );
};
